import React, { memo, useState, useEffect } from 'react'
import { Link, HeadingText, CaptionText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { PYPL_CONTACTUS_URL } from '../../constants/constants'
import { fptiCustomSetup, serverData } from '../../utils'

const SomethingWrongPage = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)
  const { dsrFpti = {} } = props

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(dsrFpti.SOMETHING_WRONG_IMPRESSION)
    }
  }, [impressionDone, dsrFpti])

  return (
    <>
      <section className="page-body-container">
        <div className="inner-container">
          <section className="common-screen">
            <div className="icon-container">
              <img
                src={`https://${serverData.cdnHostName}/dataprivacy/digitalassets/dar/Group-100131.svg`}
                alt="something-wrong"
              />
            </div>
            <HeadingText size="sm">
              <Message id="closedAccountPages.somethingwentwrong.title" />
            </HeadingText>
            <CaptionText className="marginTop">
              <Message
                id="closedAccountPages.somethingwentwrong.description"
                link={(innerMessage) => (
                  <Link theme="v2" name="contactus" href={PYPL_CONTACTUS_URL}>
                    {innerMessage}
                  </Link>
                )}
              />
            </CaptionText>
          </section>
        </div>
      </section>
    </>
  )
})
SomethingWrongPage.displayName = 'SomethingWrongPage'

export default SomethingWrongPage
